import { CmhContactState } from '@/store/new-connection-cmh/cmh-contact/types'
import { RootState } from '@/store/types'
import { GetterTree } from 'vuex'

export const getters: GetterTree<CmhContactState, RootState> = {}
